module.exports = __webpack_public_path__ + "static/media/profile.fe8bf118.svg";